
<template>
  <div class="appDashboard dashboard2">
    <div :class="{container:appConfig.container}">
      <app-header :title="title"></app-header>
    </div>
    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="md12 sm12 xs12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout style="position: absolute; left: 50px;">
            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickAutoUpdate"
            >
              {{ $t('CurrentStatus.AutoUpdate')}}
              <span v-if="isAutoUpdate">({{countDownTimer}})</span>
            </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!isAutoUpdate"
              v-on:click="onClickStopUpdate"
            >{{ $t('CurrentStatus.StopUpdate')}}</v-btn>

            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickUpdate"
            >{{ $t('CurrentStatus.ManualUpdate')}}</v-btn>
          </v-layout>
          <v-layout>
            <span v-if="onOffStatus == 'ON-LINE'" class="onStatus">{{onOffStatus}}</span>
            <span v-if="onOffStatus == 'OFF-LINE'" class="offStatus">{{onOffStatus}}</span>
          </v-layout>
          <v-layout style="position: absolute; right: 50px;">
            <v-btn depressed class="v-btn v-btn--depressed theme--light info" v-on:click="onClickTop">{{ $t('CurrentStatus.GoToTop')}}</v-btn>
            <v-btn depressed class="v-btn v-btn--depressed theme--light info" v-on:click="onClickUp">{{ $t('CurrentStatus.GoToUp')}}</v-btn>
          </v-layout>
          <object
            id="svg-fig"
            :data="svgUrl"
            type="image/svg+xml"
            width="100%"
            height="100%"
            style="margin-top: 50px;"
          ></object>
        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import mediator from "../../components/common/mediator.vue";
import moment from "moment";
import locale from "../../utility/Locale";

export default {
  name: "PackStatus",
  mixins: [mediator],

  mounted() {
    $(".appCard__header").remove();
    this.title = this.$root.currentPageName;

    this.setSvgUrl();
    setTimeout(() => {
      this.viewSVG();
      // デフォルトで自動更新
      this.onClickAutoUpdate();
    }, this.$root.svgWaitingTime);
  },
  beforeDestroy() {
    clearInterval(this.$root.currentTimer);
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      title: $t("PackStatus.Item"),
      $fig: null,
      isAutoUpdate: false,
      countDownTimer: 10,
      svgUrl: '',
      onOffStatus: '',
      isFirstRequest: true
    };
  },
  methods: {
    onClickUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
      this.viewSVG();
    },
    onClickAutoUpdate() {
      this.isAutoUpdate = true;

      this.$root.currentTimer = setInterval(() => {
        if (!this.isAutoUpdate) {
          clearInterval(this.$root.currentTimer);
        }

        if (this.countDownTimer === 0) {
          this.viewSVG();
          this.countDownTimer = 10;
        } else {
          this.countDownTimer--;
        }
      }, 1000);
    },
    onClickStopUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
    },
    onClickTop() {
      this.$router.push({ name: "top_page" });
    },
    onClickUp() {
      this.$router.push({ name: "rack_status" });
    },
    setSvgUrl() {
      if (process.env.NODE_ENV === "development") {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "/static/svg/pack_jp.svg";
        } else {
          this.svgUrl = "/static/svg/pack_cn.svg";
        }
      } else {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "static/svg/pack_jp.svg";
        } else {
          this.svgUrl = "static/svg/pack_cn.svg";
        }
      }
    },
    viewSVG() {
      let vm = this;
      vm.$fig = $(document.getElementById("svg-fig").contentDocument);

      vm.axios
        .get(`${vm.$root.url}/Customer/RackStatus4Pack`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            assign: vm.$root.assign,
            systemSn: vm.$root.currentSerial.system,
            rackSn: vm.$root.currentSerial.rack
          }
        })
        .then(response => {
          let data = response.data;
          this.onOffStatus = data[0].onOffStatus;
          if(this.isFirstRequest){
            this.isFirstRequest = false;
            this.modifyRackSVG(data);
          }
          this.setRackBase(data[0]);

          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });

      vm.axios
        .get(`${vm.$root.url}/Customer/PackStatus`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            rackSn: vm.$root.currentSerial.rack
          }
        })
        .then(response => {
          // 初期化
          let $element_ini = this.$fig.find('.st29');
          $element_ini.css('display','none');

          let data = response.data;
          this.setPackVisible(data);
          this.setPackBase(data);
          this.setErrorCode(data);
          this.setSwitch(data);
          this.setMaxMin(data);
          this.setPackImage(data);
          this.setAnimation(data);

          this.func_maxmin_line(data);

          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });
    },
    modifyRackSVG(data) {
      if(data[0].showSoe){
        this.$fig.find('.verticalBarX555-555Y40-160').css('visibility', 'hidden');
        this.$fig.find('.verticalBarX555-555Y40-185').css('visibility', 'visible');
        this.$fig.find('.rackSoeVisibility').css('visibility', 'visible');
      }
    },
    setRackBase(data) {
      let $base_txt_title = this.$fig.find('#base-txt-title');
      $base_txt_title.text(data.systemNm);

      let $base_data_rackno = this.$fig.find('#base-data-rackno');
      $base_data_rackno.text(data.rackNo);

      let $base_data_rackserial = this.$fig.find('#base-data-rackserial');
      $base_data_rackserial.text(data.rackSn);

      let $base_data_time = this.$fig.find('#base-data-time');
      $base_data_time.text(data.serverTime);

      let $base_data_voltage = this.$fig.find('#base-data-voltage');
      $base_data_voltage.text(data.totalVolt + ' V');

      let $base_data_current = this.$fig.find('#base-data-current');
      $base_data_current.text(data.totalCurrent + ' A');

      let $base_data_soc = this.$fig.find('#base-data-soc');
      $base_data_soc.text(data.soc + ' %');

      let $base_data_soe = this.$fig.find('#base-data-soe');
      $base_data_soe.text(data.soh + ' %');

      let $base_data_nominal = this.$fig.find('#base-data-nominal');
      $base_data_nominal.text(data.capacity + ' Ah');

      let $base_data_surplus = this.$fig.find('#base-data-surplus');
      $base_data_surplus.text(`${Math.round(data.capacity * (data.soh/100) * (data.soc/100))} Ah`);

      let $base_data_cell_high = this.$fig.find('#base-data-cell-high');
      $base_data_cell_high.text(data.maxCellVolt + ' V');

      let $base_data_cell_low = this.$fig.find('#base-data-cell-low');
      $base_data_cell_low.text(data.minCellVolt + ' V');

      let $base_data_cell_high_pack = this.$fig.find('#base-data-cell-high-rack');
      $base_data_cell_high_pack.text(`Pack ${data.maxVoltPack}`);

      let $base_data_cell_low_pack = this.$fig.find('#base-data-cell-low-rack');
      $base_data_cell_low_pack.text(`Pack ${data.minVoltPack}`);

      let $base_data_temp_high = this.$fig.find('#base-data-temp-high');
      $base_data_temp_high.text(data.maxTemperature + ' ℃');

      let $base_data_temp_low = this.$fig.find('#base-data-temp-low');
      $base_data_temp_low.text(data.minTemperature + ' ℃');

      let $base_data_temp_high_pack = this.$fig.find('#base-data-temp-high-rack');
      $base_data_temp_high_pack.text(`Pack ${data.maxTemperaturePack}`);

      let $base_data_temp_low_pack = this.$fig.find('#base-data-temp-low-rack');
      $base_data_temp_low_pack.text(`Pack ${data.minTemperaturePack}`);

      let $errorcode = this.$fig.find('#base-data-errorcode');
      $errorcode.text(`0x${data.rackErrorCode}`);

      const alarm = Array.from(data.alarm).reverse();
      alarm.map((error, index) => {
        let $error_f_val = null;
        let $error_txt = null;
        switch (index) {
          case 0: // OVP
            $error_f_val = this.$fig.find('#base-bg-ovp-f');
            $error_txt = this.$fig.find('#base-txt-ovp');
            break;
          case 1: // UVP
            $error_f_val = this.$fig.find('#base-bg-uvp-f');
            $error_txt = this.$fig.find('#base-txt-uvp');
            break;
          case 2: // OCP
            $error_f_val = this.$fig.find('#base-bg-ocp-f');
            $error_txt = this.$fig.find('#base-txt-ocp');
            break;
          case 3: // UCP
            $error_f_val = this.$fig.find('#base-bg-ucp-f');
            $error_txt = this.$fig.find('#base-txt-ucp');
            break;
          case 4: // OTP
            $error_f_val = this.$fig.find('#base-bg-otp-f');
            $error_txt = this.$fig.find('#base-txt-otp');
            break;
          case 5: // UTP
            $error_f_val = this.$fig.find('#base-bg-utp-f');
            $error_txt = this.$fig.find('#base-txt-utp');
            break;
        }

        if (error === "1") {
          if ($error_f_val) {
            $error_f_val.css('display', 'inherit');
            $error_f_val.css('fill', '#ff3121');
            $error_txt.css('fill', '#ffffff');
          }
        } else {
          if ($error_f_val) {
            $error_f_val.css('display', 'none');
            $error_txt.css('fill', '#727272');
          }
        }
      });
    },

    setPackVisible(data) {
      var packCount = data[0].packCount;
      for (var i = 0; i < packCount; i++) {
        let $pack = this.$fig.find(`#pack-${data[i].packNo}`);
        $pack.data('packSn', data[i].packSn);

        let screenleft = 0;
        let screenwdth = 1710;
        let $onoff_val = this.$fig.find(`#pack-${data[i].packNo}`);
        if (i <= packCount) {
          $onoff_val.css('display', 'inline');
        } else {
          $onoff_val.css('display', 'none');
        }

        let pos = ((screenwdth / packCount) * i);
        $onoff_val.attr('transform', 'translate(' + pos + ',0)');

        $pack.off('click');
        if ((this.$root.userRole).at(-1) == 4) {
          $pack.on('click', (event) => {
            this.$root.currentSerial.pack = $(event.currentTarget).data("packSn");
            this.$router.push({ name: "cell_status" });
          });
        }
      }

      if ((this.$root.userRole).at(-1) < 4) {
        // Do not use the finger pointer
        this.$fig.find(`.st28`).css('cursor', 'default');
      };

      let screenwdth = 1710;
      let $base_current_line_01_path = this.$fig.find('#base-current-line-01-path');
      let $base_current_line_02_path = this.$fig.find('#base-current-line-02-path');
      let $base_current_line_01_circle = this.$fig.find('#base-current-line-01-blink circle');

      let pos_end = ((screenwdth / packCount) * (packCount - 1)) + 180;
      $base_current_line_01_path.attr('x2', pos_end);
      $base_current_line_02_path.attr('d', 'M' + pos_end + ',445 L45,445 45,360');

      if(packCount == 1){
        let $base_current_line_02 = this.$fig.find('#base-current-line-02');
        let $circle_01 = $base_current_line_02.find('circle:nth-child(2)');
        let $circle_01_animate = $circle_01.find('animateMotion');
        let $circle_02 = $base_current_line_02.find('circle:nth-child(3)');
        let $circle_02_animate = $circle_02.find('animateMotion');
        let $circle_03 = $base_current_line_02.find('circle:nth-child(4)');
        let $circle_03_animate = $circle_03.find('animateMotion');
        let $circle_none = $base_current_line_02.find('circle:nth-child(n+5)');

        $circle_none.css("display", "none");
        $circle_01_animate.attr("dur", "0.9s");
        $circle_02_animate.attr("dur", "0.9s");
        $circle_03_animate.attr("dur", "0.9s");
        $circle_01_animate.attr("begin", "0s");
        $circle_02_animate.attr("begin", "0.3s");
        $circle_03_animate.attr("begin", "0.6s");
      }

      $base_current_line_01_circle.each(function () {
        let $blink_pos = $(this).attr('cx');
        if (parseInt($blink_pos) >= pos_end) {
          $(this).css('display', 'none');
        }
      });
    },

    setPackBase(data) {
      data.map(pack => {
        let $packname_val = this.$fig.find(`#pack-txt-packname-${pack.packNo}`);
        if (pack.packNo != undefined && pack.packNo != null) {
          $packname_val.text(`PACK_${pack.packNo}`);
        }

        let $totalCurrent = this.$fig.find(`#pack-data-current-${pack.packNo}`);
        if (pack.totalCurrent != undefined && pack.totalCurrent != null) {
          $totalCurrent.text(`${pack.packNo}A`);
        }

        let $totalVolt = this.$fig.find(`#pack-data-volt-${pack.packNo}`);
        if (pack.totalVolt != undefined && pack.totalVolt != null) {
          $totalVolt.text(`${pack.totalVolt}V`);
        }

        let $soc = this.$fig.find(`#pack-data-soc-${pack.packNo}`);
        if (pack.soc != undefined && pack.soc != null) {
          $soc.text(`${pack.soc}%`);
        }

        let $maxCellVolt = this.$fig.find(`#pack-data-cell-high-${pack.packNo}`);
        if (pack.maxCellVolt != undefined && pack.maxCellVolt != null) {
          $maxCellVolt.text(`${pack.maxCellVolt}V`);
        }

        let $minCellVolt = this.$fig.find(`#pack-data-cell-low-${pack.packNo}`);
        if (pack.minCellVolt != undefined && pack.minCellVolt != null) {
          $minCellVolt.text(`${pack.minCellVolt}V`);
        }

        let $maxVoltPack = this.$fig.find(`#pack-data-cell-high-cell-${pack.packNo}`);
        if (pack.maxVoltPack != undefined && pack.maxVoltPack != null) {
          $maxVoltPack.text(`Cell ${pack.maxVoltPack}`);
        }

        let $minVoltPack = this.$fig.find(`#pack-data-cell-low-cell-${pack.packNo}`);
        if (pack.minVoltPack != undefined && pack.minVoltPack != null) {
          $minVoltPack.text(`Cell ${pack.minVoltPack}`);
        }

        let $maxTemperature = this.$fig.find(`#pack-data-temp-high-${pack.packNo}`);
        if (pack.maxTemperature != undefined && pack.maxTemperature != null) {
          $maxTemperature.text(`${pack.maxTemperature}℃`);
        }

        let $minTemperature = this.$fig.find(`#pack-data-temp-low-${pack.packNo}`);
        if (pack.minTemperature != undefined && pack.minTemperature != null) {
          $minTemperature.text(`${pack.minTemperature}℃`);
        }

        let $maxTemperaturePack = this.$fig.find(`#pack-data-temp-high-cell-${pack.packNo}`);
        if (pack.maxTemperaturePack != undefined && pack.maxTemperaturePack != null) {
          $maxTemperaturePack.text(`Temp ${pack.maxTemperaturePack}`);
        }

        let $minTemperaturePack = this.$fig.find(`#pack-data-temp-low-cell-${pack.packNo}`);
        if (pack.minTemperaturePack != undefined && pack.minTemperaturePack != null) {
          $minTemperaturePack.text(`Temp ${pack.minTemperaturePack}`);
        }

        let $packno_a_val = this.$fig.find(`#pack-txt-no-${pack.packNo}a`);
        let $packno_b_val = this.$fig.find(`#pack-txt-no-${pack.packNo}b`);
        if(pack.packSn){
          $packno_a_val.text(pack.packSn.substr(0, 8));
          $packno_b_val.text(pack.packSn.substr(8));
        }
      });
    },

    setMaxMin(data) {
      let PackCntVl = data[0].packCount;
      let volt_maxmin = [];
      let soc_maxmin = [];
      let soh_maxmin = [];
      let cell_high_maxmin = [];
      let cell_low_maxmin = [];
      let temp_high_maxmin = [];
      let temp_low_maxmin = [];

      data.map(pack => {
        volt_maxmin.push(pack.totalVolt);
        soc_maxmin.push(pack.soc);
        soh_maxmin.push(pack.soh);
        cell_high_maxmin.push(pack.maxCellVolt);
        cell_low_maxmin.push(pack.minCellVolt);
        temp_high_maxmin.push(pack.maxTemperature);
        temp_low_maxmin.push(pack.minTemperature);
      });

      let volt_max_val = Math.max.apply(null, volt_maxmin.slice(0, PackCntVl));
      let volt_min_val = Math.min.apply(null, volt_maxmin.slice(0, PackCntVl));
      let soc_max_val = Math.max.apply(null, soc_maxmin.slice(0, PackCntVl));
      let soc_min_val = Math.min.apply(null, soc_maxmin.slice(0, PackCntVl));
      let soh_max_val = Math.max.apply(null, soh_maxmin.slice(0, PackCntVl));
      let soh_min_val = Math.min.apply(null, soh_maxmin.slice(0, PackCntVl));
      let cell_high_max_val = Math.max.apply(null, cell_high_maxmin.slice(0, PackCntVl));
      let cell_high_min_val = Math.min.apply(null, cell_high_maxmin.slice(0, PackCntVl));
      let cell_low_max_val = Math.max.apply(null, cell_low_maxmin.slice(0, PackCntVl));
      let cell_low_min_val = Math.min.apply(null, cell_low_maxmin.slice(0, PackCntVl));
      let temp_high_max_val = Math.max.apply(null, temp_high_maxmin.slice(0, PackCntVl));
      let temp_high_min_val = Math.min.apply(null, temp_high_maxmin.slice(0, PackCntVl));
      let temp_low_max_val = Math.max.apply(null, temp_low_maxmin.slice(0, PackCntVl));
      let temp_low_min_val = Math.min.apply(null, temp_low_maxmin.slice(0, PackCntVl));

      data.map(pack => {
        let $svg_volt = this.$fig.find(`#pack-maxmin-volt-${pack.packNo}`);
        if (volt_max_val != volt_min_val) {
          if (pack.totalVolt == volt_max_val) {
            $svg_volt.css('display', 'inherit');
            $svg_volt.css('fill', '#378bd1');
          } else if (pack.totalVolt == volt_min_val) {
            $svg_volt.css('display', 'inherit');
            $svg_volt.css('fill', '#99536e');
          } else {
            $svg_volt.css('display', 'none');
          }
        }

        let $svg_soc = this.$fig.find(`#pack-maxmin-soc-${pack.packNo}`);
        if (soc_max_val != soc_min_val) {
          if (pack.soc == soc_max_val) {
            $svg_soc.css('display', 'inherit');
            $svg_soc.css('fill', '#378bd1');
          } else if (pack.soc == soc_min_val) {
            $svg_soc.css('display', 'inherit');
            $svg_soc.css('fill', '#99536e');
          } else {
            $svg_soc.css('display', 'none');
          }
        }

        let $svg_soh = this.$fig.find(`#pack-maxmin-soh-${pack.packNo}`);
        if (soh_max_val != soh_min_val) {
          if (pack.soh == soh_max_val) {
            $svg_soh.css('display', 'inherit');
            $svg_soh.css('fill', '#378bd1');
          } else if (pack.soh == soh_min_val) {
            $svg_soh.css('display', 'inherit');
            $svg_soh.css('fill', '#99536e');
          } else {
            $svg_soh.css('display', 'none');
          }
        }

        let $svg_cell_high = this.$fig.find(`#pack-maxmin-cell-high-${pack.packNo}`);
        if (cell_high_max_val != cell_high_min_val) {
          if (pack.maxCellVolt == cell_high_max_val) {
            $svg_cell_high.css('display', 'inherit');
            $svg_cell_high.css('fill', '#378bd1');
          } else if (pack.maxCellVolt == cell_high_min_val) {
            $svg_cell_high.css('display', 'inherit');
            $svg_cell_high.css('fill', '#99536e');
          } else {
            $svg_cell_high.css('display', 'none');
          }
        }

        let $svg_cell_low = this.$fig.find(`#pack-maxmin-cell-low-${pack.packNo}`);
        if (cell_low_max_val != cell_low_min_val) {
          if (pack.minCellVolt == cell_low_max_val) {
            $svg_cell_low.css('display', 'inherit');
            $svg_cell_low.css('fill', '#378bd1');
          } else if (pack.minCellVolt == cell_low_min_val) {
            $svg_cell_low.css('display', 'inherit');
            $svg_cell_low.css('fill', '#99536e');
          } else {
            $svg_cell_low.css('display', 'none');
          }
        }

        let $svg_temp_high = this.$fig.find(`#pack-maxmin-temp-high-${pack.packNo}`);
        if (temp_high_max_val != temp_high_min_val) {
          if (pack.maxTemperature == temp_high_max_val) {
            $svg_temp_high.css('display', 'inherit');
            $svg_temp_high.css('fill', '#378bd1');
          } else if (pack.maxTemperature == temp_high_min_val) {
            $svg_temp_high.css('display', 'inherit');
            $svg_temp_high.css('fill', '#99536e');
          } else {
            $svg_temp_high.css('display', 'none');
          }
        }

        let $svg_temp_low = this.$fig.find(`#pack-maxmin-temp-low-${pack.packNo}`);
        if (temp_low_max_val != temp_low_min_val) {
          if (pack.minTemperature == temp_low_max_val) {
            $svg_temp_low.css('display', 'inherit');
            $svg_temp_low.css('fill', '#378bd1');
          } else if (pack.minTemperature == temp_low_min_val) {
            $svg_temp_low.css('display', 'inherit');
            $svg_temp_low.css('fill', '#99536e');
          } else {
            $svg_temp_low.css('display', 'none');
          }
        }

      });
    },

    setErrorCode(data) {
      data.map(pack => {
        const alarm = Array.from(pack.alarm).reverse();
        alarm.map((error, index) => {
          let $error_f_val = null;
          let $error_txt = null;
          switch (index) {
            case 0: // OVP
              $error_f_val = this.$fig.find(`#pack-bg-ovp-f-${pack.packNo}`);
              $error_txt = this.$fig.find(`#pack-txt-ovp-${pack.packNo}`);
              break;
            case 1: // UVP
              $error_f_val = this.$fig.find(`#pack-bg-uvp-f-${pack.packNo}`);
              $error_txt = this.$fig.find(`#pack-txt-uvp-${pack.packNo}`);
              break;
            case 2: // OCP
              $error_f_val = this.$fig.find(`#pack-bg-ocp-f-${pack.packNo}`);
              $error_txt = this.$fig.find(`#pack-txt-ocp-${pack.packNo}`);
              break;
            case 3: // UCP
              $error_f_val = this.$fig.find(`#pack-bg-ucp-f-${pack.packNo}`);
              $error_txt = this.$fig.find(`#pack-txt-ucp-${pack.packNo}`);
              break;
            case 4: // OTP
              $error_f_val = this.$fig.find(`#pack-bg-otp-f-${pack.packNo}`);
              $error_txt = this.$fig.find(`#pack-txt-otp-${pack.packNo}`);
              break;
            case 5: // UTP
              $error_f_val = this.$fig.find(`#pack-bg-utp-f-${pack.packNo}`);
              $error_txt = this.$fig.find(`#pack-txt-utp-${pack.packNo}`);
              break;
          }

          if (error === "1") {
            if ($error_f_val) {
              $error_f_val.css('display', 'inherit');
              $error_f_val.css('fill', '#ff3121');
              $error_txt.css('fill', '#ffffff');
            }
          } else {
            if ($error_f_val) {
              $error_f_val.css('display', 'none');
              $error_txt.css('fill', '#727272');
            }
          }
        });
      });
    },

    setSwitch(data) {
      let switchDirCount_0 = 0;
      let switchDirCount_1 = 0;
      data.map(pack => {
        let $switch_off_val = this.$fig.find(`#pack-switch-off-${pack.packNo}`);
        let $switch_on_val = this.$fig.find(`#pack-switch-on-${pack.packNo}`);
        let $base_switch_anime = $switch_on_val.find('animateMotion');
        $switch_on_val.css('display', 'inline');
        $switch_off_val.css('display', 'none');
        if (pack.switchOnOff === 0) {
          if (pack.switchDir === 0) {
            $base_switch_anime.attr('keyPoints','1;0');
            $base_switch_anime.attr('keyTimes','0;1');
            $base_switch_anime.attr('calcMode','linear');
          } else {
            $base_switch_anime.attr('keyPoints','0;1');
            $base_switch_anime.attr('keyTimes','0;1');
            $base_switch_anime.attr('calcMode','linear');
          }
        } else {
          $switch_on_val.css('display', 'none');
          $switch_off_val.css('display', 'inline');
        }

        if (Number(pack.packNo) === data[0].packCount) {
          this.$fig.find(`#pack-switch-off-${pack.packNo}`).children().eq(2).attr('x2', '180');
        }
      });
    },

    setPackImage(data) {
      data.map(pack => {
        //電池残量図示
        if (pack.soc > 100) {
          pack.soc = 100;
        }

        let barheight = 99 * pack.soc / 100;
        let positiony = 388;

        let $pack_scale_red = this.$fig.find(`#pack-scale-red-${pack.packNo}`);
        let $pack_scale_yellow = this.$fig.find(`#pack-scale-yellow-${pack.packNo}`);
        let $pack_scale_green = this.$fig.find(`#pack-scale-green-${pack.packNo}`);
        let $pack_scale_error = this.$fig.find(`#pack-scale-error-${pack.packNo}`);

        let allError = false;
        const alarm = Array.from(pack.alarm).reverse();
        alarm.map((error, index) => {
          if (error === "1") {
            allError = true;
          }
        });

        if (allError) {
          $pack_scale_error.css('display', 'inherit');
          $pack_scale_error.css('height', barheight);
          $pack_scale_error.attr('y', positiony + 99 - barheight);
          $pack_scale_red.css('display', 'none');
          $pack_scale_yellow.css('display', 'none');
          $pack_scale_green.css('display', 'none');
        } else {
          if (pack.soc <= 20) {
            $pack_scale_red.css('display', 'inherit');
            $pack_scale_red.css('height', barheight);
            $pack_scale_red.attr('y', positiony + 99 - barheight);
            $pack_scale_yellow.css('display', 'none');
            $pack_scale_green.css('display', 'none');
            $pack_scale_error.css('display', 'none');
          } else if (pack.soc <= 50) {
            $pack_scale_red.css('display', 'none');
            $pack_scale_yellow.css('display', 'inherit');
            $pack_scale_yellow.css('height', barheight);
            $pack_scale_yellow.attr('y', positiony + 99 - barheight);
            $pack_scale_green.css('display', 'none');
            $pack_scale_error.css('display', 'none');
          } else {
            $pack_scale_red.css('display', 'none');
            $pack_scale_yellow.css('display', 'none');
            $pack_scale_green.css('display', 'inherit');
            $pack_scale_green.css('height', barheight);
            $pack_scale_green.attr('y', positiony + 99 - barheight);
            $pack_scale_error.css('display', 'none');
          }
        }
      });
    },

    setAnimation(data) {
      //全スイッチoffのときの横方向電流
      let $base_current_line_01 = this.$fig.find('#base-current-line-01');
      let $base_current_line_01_path = this.$fig.find('#base-current-line-01-path');
      let $base_current_line_01_blink = this.$fig.find('#base-current-line-01-blink');

      $base_current_line_01.css('display', 'inherit');

      let switchsum = 0;
      data.map(pack => {
        if (pack.switchOnOff) {
          switchsum = switchsum + pack.switchOnOff;
        }
      });

      if (switchsum === data[0].packCount) {
        $base_current_line_01_path.css('stroke','#FFFFFF');
        $base_current_line_01_blink.css('display','none');
      }

      // //pack間の電流
      let $base_current_line_02 = this.$fig.find('#base-current-line-02');
      let $base_current_line_02_path = this.$fig.find('#base-current-line-02-path');
      let $base_current_line_02_anime = $base_current_line_02.find('animateMotion');

      // RackのリレーやIHSの状態によってもアニメーションを変化させる
      if (data[0].switchOnOffRack == 1 && data[0].ihsOnOffRack == 1 && data[0].ihsUvpRack != 1 && data[0].totalCurrent > 0) {
        $base_current_line_02.css('display','inherit');
        $base_current_line_02_path.css('stroke','#33aaee');
        $base_current_line_02_anime.attr('keyPoints','0;1');
        $base_current_line_02_anime.attr('keyTimes','0;1');
        $base_current_line_02_anime.attr('calcMode','linear');
      } else if (data[0].switchOnOffRack == 1 && data[0].ihsOnOffRack == 1 && data[0].ihsOvpRack != 1 && data[0].totalCurrent < 0) {
        $base_current_line_02.css('display', 'inherit');
        $base_current_line_02_path.css('stroke', '#33aaee');
        let $base_current_line_02_anime = $base_current_line_02.find('animateMotion');
        $base_current_line_02_anime.attr('keyPoints', '1;0');
        $base_current_line_02_anime.attr('keyTimes', '0;1');
        $base_current_line_02_anime.attr('calcMode', 'linear');
      } else {
        $base_current_line_02.css('display', 'none');
      }
    },

    // 5/26対応分
    func_maxmin_line(data) {
      var pack_on = [];
      var pack_direction = [];
      let PackCntVl = data[0].packCount;
      let screenwdth = 1710;

      let pos_end = ((screenwdth / PackCntVl) * (PackCntVl - 1)) + 180;
      let $base_current_line_01_circle = this.$fig.find('#base-current-line-01-blink circle');
      $base_current_line_01_circle.each(function () {
        let $blink_pos = $(this).attr('cx');
        if (parseInt($blink_pos) >= pos_end) {
          $(this).css("visibility", "hidden");
        } else {//2020-5-27 13:00追加
          $(this).css("visibility", "visible");
        }
      });

      data.map((pack, index) => {
        if(pack.switchOnOff === 0 && index < PackCntVl){
          pack_on.push(index + 1);
          pack_direction.push(pack.switchDir);
        }
      });

      let $base_current_line_01_path = this.$fig.find('#base-current-line-01-path');
      let $base_current_line_01b_path = this.$fig.find('#base-current-line-01b-path');

      if (pack_direction.indexOf(1) >= 0 && pack_direction.indexOf(0) >= 0){
        $base_current_line_01_path.css('stroke','#FFFFFF');

        let pack_on_first = pack_on[0];
        let pack_on_last = pack_on[pack_on.length - 1];

        let line_01b_x_first = (screenwdth / PackCntVl) * (pack_on_first-1) + 180;
        let line_01b_x_last = (screenwdth / PackCntVl) * (pack_on_last-1) + 180;

        $base_current_line_01b_path.css("display", "inherit");
        $base_current_line_01b_path.attr('x1',line_01b_x_first);
        $base_current_line_01b_path.attr('x2',line_01b_x_last);

        $base_current_line_01_circle.each(function() {
          let $blink_pos = $(this).attr('cx');
          if(parseInt($blink_pos) <= line_01b_x_first || parseInt($blink_pos) >= line_01b_x_last){
            $(this).css("visibility", "hidden");
          } else {
            $(this).css("visibility", "visible");
          }
        });
      } else {
        $base_current_line_01b_path.css("display", "none");
      }
    }
  }
};
</script>

<style>
.dashboard2 {
  z-index: 9;
}

.dashboard2 .offset-sm3 {
  margin: 0 !important;
  flex-basis: 100% !important;
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/router/Customer/PackStatus.vue